/**
 * @description 「是」或「否」文字 (enum)
 */
export enum YesNoTextEnum {
  /** 否 */
  No = '否',
  /** 是 */
  Yes = '是'
}
